import React from 'react';
import TextField from '@material-ui/core/TextField';
import { isNull,isUndefined } from 'lodash';
import {injectIntl} from 'react-intl';


function NotyInputs(props) {
    const Option9=[
    {value:"",Meta: props.intl.formatMessage({ id: 'Choose' })},
    {value:'Afghanistan',Meta: props.intl.formatMessage({ id: 'Land.Afghanistan' }) } ,
{value:'Albanien',Meta: props.intl.formatMessage({ id: 'Land.Albania' }) },
{value:'Algeriet',Meta: props.intl.formatMessage({ id: 'Land.Algeria' }) },
{value:'Andorra',Meta: props.intl.formatMessage({ id: 'Land.Andorra' }) },
{value:'Angola',Meta: props.intl.formatMessage({ id: 'Land.Angola' }) },
{value:'Antigua och Barbuda',Meta: props.intl.formatMessage({ id: 'Land.AntiguaAndBarbuda' }) },
{value:'Argentina',Meta:props.intl.formatMessage({ id: 'Land.Argentina' })},
{value:'Armenien',Meta: props.intl.formatMessage({ id: 'Land.Armenia' })},
{value:'Australien',Meta:props.intl.formatMessage({ id: 'Land.Australia' })},
{value:'Azerbajdzjan',Meta: props.intl.formatMessage({ id: 'Land.Azerbaijan' })},
{value:'Bahamas',Meta: props.intl.formatMessage({ id: 'Land.Bahamas' })},
{value:'Bahrain',Meta: props.intl.formatMessage({ id: 'Land.Bahrain' })},
{value:'Bangladesh',Meta: props.intl.formatMessage({ id: 'Land.Bangladesh' })},
{value:'Barbados',Meta: props.intl.formatMessage({ id: 'Land.Barbados' })},
{value:'Belgien',Meta: props.intl.formatMessage({ id: 'Land.Belgium' })},
{value:'Belize',Meta: props.intl.formatMessage({ id: 'Land.Belize' })},
{value:'Benin',Meta: props.intl.formatMessage({ id: 'Land.Benin' })},
{value:'Bhutan',Meta: props.intl.formatMessage({ id: 'Land.Bhutan' })},
{value:'Bolivia',Meta: props.intl.formatMessage({ id: 'Land.Bolivia' })},
{value:'Bosnien och Hercegovina',Meta:props.intl.formatMessage({ id: 'Land.BosniaAndHerzegovina' })},
{value:'Botswana',Meta: props.intl.formatMessage({ id: 'Land.Botswana' })},
{value:'Brasilien',Meta: props.intl.formatMessage({ id: 'Land.Brazil' })},
{value:'Brunei',Meta: props.intl.formatMessage({ id: 'Land.Brunei' })},
{value:'Bulgarien',Meta: props.intl.formatMessage({ id: 'Land.Bulgaria' })},
{value:'Burkina Faso',Meta: props.intl.formatMessage({ id: 'Land.BurkinaFaso' })},
{value:'Burma (Myanmar)',Meta:props.intl.formatMessage({ id: 'Land.Myamar' })},
{value:'Burundi',Meta: props.intl.formatMessage({ id: 'Land.Burundi' })},
{value:'Canada',Meta: props.intl.formatMessage({ id: 'Land.Canada' })},
{value:'Centralafrikanska republiken',Meta: props.intl.formatMessage({ id: 'Land.CentralAfricanRepublic' })},
{value:'Chile',Meta: props.intl.formatMessage({ id: 'Land.Chile' })},
{value:'Colombia',Meta: props.intl.formatMessage({ id: 'Land.Colombia' })},
{value:'Comorerna',Meta: props.intl.formatMessage({ id: 'Land.Comoros' })},
{value:'Costa Rica',Meta: props.intl.formatMessage({ id: 'Land.CostaRica' })},
{value:'Cuba',Meta: props.intl.formatMessage({ id: 'Land.Cuba' })},
{value:'Cypern',Meta: props.intl.formatMessage({ id: 'Land.Cyprus' })},
{value:'Danmark',Meta: props.intl.formatMessage({ id: 'Land.Denmark' })},
{value:'Denmark',Meta: props.intl.formatMessage({ id: 'Land.Denmark' })},
{value:'Djibouti',Meta: props.intl.formatMessage({ id: 'Land.Djibouti' })},
{value:'Dominica',Meta: props.intl.formatMessage({ id: 'Land.Dominica' })},
{value:'Dominikanska republiken',Meta: props.intl.formatMessage({ id: 'Land.DominicanRepublic' })},
{value:'Ecuador',Meta: props.intl.formatMessage({ id: 'Land.Ecuador' })},
{value:'Egypten',Meta: props.intl.formatMessage({ id: 'Land.Egypt' })},
{value:'Ekvatorialguinea',Meta: props.intl.formatMessage({ id: 'Land.EquatorialGuinea' })},
{value:'Elfenbenskusten',Meta: props.intl.formatMessage({ id: 'Land.CoteDIvoire' })},
{value:'El Salvador',Meta: props.intl.formatMessage({ id: 'Land.ElSalvador' })},
{value:'Eritrea',Meta: props.intl.formatMessage({ id: 'Land.Eritrea' })},
{value:'Estland',Meta: props.intl.formatMessage({ id: 'Land.Estonia' })},
{value:'Etiopien',Meta: props.intl.formatMessage({ id: 'Land.Ethiopia' })},
{value:'Fiji',Meta: props.intl.formatMessage({ id: 'Land.Fiji' })},
{value:'Filippinerna',Meta: props.intl.formatMessage({ id: 'Land.Philippines' })},
{value:'Finland',Meta: props.intl.formatMessage({ id: 'Land.Finland' })},
{value:'Frankrike',Meta: props.intl.formatMessage({ id: 'Land.France' })},
{value:'Förenade Arabemiraten',Meta: props.intl.formatMessage({ id: 'Land.UnitedArabEmirates' })},
{value:'Gabon',Meta: props.intl.formatMessage({ id: 'Land.Gabon' })},
{value:'Gambia',Meta: props.intl.formatMessage({ id: 'Land.Gambia' })},
{value:'Georgien',Meta: props.intl.formatMessage({ id: 'Land.Georgia' })},
{value:'Ghana',Meta: props.intl.formatMessage({ id: 'Land.Ghana' })},
{value:'Grekland',Meta: props.intl.formatMessage({ id: 'Land.Greece' })},
{value:'Grenada',Meta: props.intl.formatMessage({ id: 'Land.Grenada' })},
{value:'Guernsey',Meta: props.intl.formatMessage({ id: 'Land.Guernsey' })},
{value:'Guatemala',Meta: props.intl.formatMessage({ id: 'Land.Guatemala' })},
{value:'Guinea',Meta: props.intl.formatMessage({ id: 'Land.Guinea' })},
{value:'Guinea-Bissau',Meta: props.intl.formatMessage({ id: 'Land.GuineaBissau' })},
{value:'Guyana',Meta: props.intl.formatMessage({ id: 'Land.Guyana' })},
{value:'Haiti',Meta: props.intl.formatMessage({ id: 'Land.Haiti' })},
{value:'Honduras',Meta: props.intl.formatMessage({ id: 'Land.Honduras' })},
{value:'Indien',Meta: props.intl.formatMessage({ id: 'Land.India' })},
{value:'Indonesien',Meta: props.intl.formatMessage({ id: 'Land.Indonesia' })},
{value:'Irak',Meta: props.intl.formatMessage({ id: 'Land.Iraq' })},
{value:'Iran',Meta: props.intl.formatMessage({ id: 'Land.Iran' })},
{value:'Irland',Meta: props.intl.formatMessage({ id: 'Land.Ireland' })},
{value:'Island',Meta: props.intl.formatMessage({ id: 'Land.Iceland' })},
{value:'Israel',Meta: props.intl.formatMessage({ id: 'Land.Israel'})},
{value:'Italien',Meta: props.intl.formatMessage({ id: 'Land.Italy' })},
{value:'Isle of man',Meta: props.intl.formatMessage({ id: 'Land.IsleOfMan' })},
{value:'Jamaica',Meta: props.intl.formatMessage({ id: 'Land.Jamaica' })},
{value:'Japan',Meta: props.intl.formatMessage({ id: 'Land.Japan' })},
{value:'Jordanien',Meta: props.intl.formatMessage({ id: 'Land.Jordan' })},
{value:'Kambodja',Meta: props.intl.formatMessage({ id: 'Land.Cambodia' })},
{value:'Kamerun',Meta: props.intl.formatMessage({ id: 'Land.Cameroon' })},
{value:'Kap Verde',Meta: props.intl.formatMessage({ id: 'Land.CapeVerde' })},
{value:'Kazakstan',Meta: props.intl.formatMessage({ id: 'Land.Kazakhstan' })},
{value:'Kenya',Meta: props.intl.formatMessage({ id: 'Land.Kenya' })},
{value:'Kina',Meta: props.intl.formatMessage({ id: 'Land.China' })},
{value:'Kirgizistan',Meta: props.intl.formatMessage({ id: 'Land.Kyrgyzstan' })},
{value:'Kiribati',Meta: props.intl.formatMessage({ id: 'Land.Kiribati' })},
{value:'Kongo (Brazzaville)',Meta: props.intl.formatMessage({ id: 'Land.CongoBrazzaville' })},
{value:'Kongo (Kinshasa)',Meta: props.intl.formatMessage({ id: 'Land.CongoKinshasa' })},
{value:'Kroatien',Meta: props.intl.formatMessage({ id: 'Land.Croatia' })},
{value:'Kosovo',Meta: props.intl.formatMessage({ id: 'Land.Kosovo' })},
{value:'Kuwait',Meta: props.intl.formatMessage({ id: 'Land.Kuwait' })},
{value:'Laos',Meta: props.intl.formatMessage({ id: 'Land.Laos' })},
{value:'Lesotho',Meta: props.intl.formatMessage({ id: 'Land.Lesotho' })},
{value:'Lettland',Meta: props.intl.formatMessage({ id: 'Land.Latvia' })},
{value:'Libanon',Meta: props.intl.formatMessage({ id: 'Land.Lebanon' })},
{value:'Liberia',Meta: props.intl.formatMessage({ id: 'Land.Liberia' })},
{value:'Libyen',Meta: props.intl.formatMessage({ id: 'Land.Libya' })},
{value:'Liechtenstein',Meta: props.intl.formatMessage({ id: 'Land.Liechtenstein' })},
{value:'Litauen',Meta: props.intl.formatMessage({ id: 'Land.Lithuania' })},
{value:'Luxemburg',Meta: props.intl.formatMessage({ id: 'Land.Luxembourg' })},
{value:'Madagaskar',Meta: props.intl.formatMessage({ id: 'Land.Madagascar' })},
{value:'Macao',Meta: props.intl.formatMessage({ id: 'Land.Macao' })},
{value:'Makedonien',Meta: props.intl.formatMessage({ id: 'Land.Macedonia' })},
{value:'Malawi',Meta: props.intl.formatMessage({ id: 'Land.Malawi' })},
{value:'Malaysia',Meta: props.intl.formatMessage({ id: 'Land.Malaysia' })},
{value:'Maldiverna',Meta: props.intl.formatMessage({ id: 'Land.Maldives' })},
{value:'Mali',Meta: props.intl.formatMessage({ id: 'Land.Mali' })},
{value:'Malta',Meta: props.intl.formatMessage({ id: 'Land.Malta' })},
{value:'Marocko',Meta: props.intl.formatMessage({ id: 'Land.Morocco' })},
{value:'Marshallöarna',Meta: props.intl.formatMessage({ id: 'Land.MarshallIslands' })},
{value:'Mauretanien',Meta: props.intl.formatMessage({ id: 'Land.Mauritania' })},
{value:'Mauritius',Meta: props.intl.formatMessage({ id: 'Land.Mauritius' })},
{value:'Mexico',Meta: props.intl.formatMessage({ id: 'Land.Mexico' })},
{value:'Mikronesiska federationen',Meta: props.intl.formatMessage({ id: 'Land.Micronesia' })},
{value:'Moçambique',Meta: props.intl.formatMessage({ id: 'Land.Mozambique' })},
{value:'Moldavien',Meta: props.intl.formatMessage({ id: 'Land.Moldova' })},
{value:'Monaco',Meta: props.intl.formatMessage({ id: 'Land.Monaco' })},
{value:'Mongoliet',Meta: props.intl.formatMessage({ id: 'Land.Mongolia' })},
{value:'Montenegro',Meta: props.intl.formatMessage({ id: 'Land.Montenegro' })},
{value:'Namibia',Meta: props.intl.formatMessage({ id: 'Land.Namibia' })},
{value:'Nauru',Meta: props.intl.formatMessage({ id: 'Land.Nauru' })},
{value:'Nederländerna',Meta: props.intl.formatMessage({ id: 'Land.Netherlands' })},
{value:'Nepal',Meta: props.intl.formatMessage({ id: 'Land.Nepal' })},
{value:'Nicaragua',Meta: props.intl.formatMessage({ id: 'Land.Nicaragua' })},
{value:'Niger',Meta: props.intl.formatMessage({ id: 'Land.Niger' })},
{value:'Nigeria',Meta: props.intl.formatMessage({ id: 'Land.Nigeria' })},
{value:'Nordkorea',Meta: props.intl.formatMessage({ id: 'Land.NorthKorea' })},
{value:'Norge',Meta: props.intl.formatMessage({ id: 'Land.Norway' })},
{value:'Nya Zeeland',Meta: props.intl.formatMessage({ id: 'Land.NewZealand' })},
{value:'Oman',Meta: props.intl.formatMessage({ id: 'Land.Oman' })},
{value:'Pakistan',Meta: props.intl.formatMessage({ id: 'Land.Pakistan' })},
{value:'Palau',Meta: props.intl.formatMessage({ id: 'Land.Palau' })},
{value:'Panama',Meta: props.intl.formatMessage({ id: 'Land.Panama' })},
{value:'Papua Nya Guinea',Meta: props.intl.formatMessage({ id: 'Land.PapuaNewGuinea' })},
{value:'Paraguay',Meta: props.intl.formatMessage({ id: 'Land.Paraguay' })},
{value:'Peru',Meta: props.intl.formatMessage({ id: 'Land.Peru' })},
{value:'Polen',Meta: props.intl.formatMessage({ id: 'Land.Poland' })},
{value:'Portugal',Meta: props.intl.formatMessage({ id: 'Land.Portugal' })},
{value:'Qatar',Meta: props.intl.formatMessage({ id: 'Land.Qatar' })},
{value:'Rumänien',Meta: props.intl.formatMessage({ id: 'Land.Romania' })},
{value:'Rwanda',Meta: props.intl.formatMessage({ id: 'Land.Rwanda' })},
{value:'Ryska federationen',Meta: props.intl.formatMessage({ id: 'Land.Russia' })},
{value:'Saint Christopher och Nevis',Meta: props.intl.formatMessage({ id: 'Land.SaintKittsAndNevis' })},
{value:'Saint Lucia',Meta: props.intl.formatMessage({ id: 'Land.SaintLucia' })},
{value:'Saint Vincent och Grenadinerna',Meta: props.intl.formatMessage({ id: 'Land.SaintVincentAndTheGrenadines' })},
{value:'Salomonöarna',Meta: props.intl.formatMessage({ id: 'Land.SolomonIslands' })},
{value:'Samoa',Meta: props.intl.formatMessage({ id: 'Land.Samoa' })},
{value:'San Marino',Meta: props.intl.formatMessage({ id: 'Land.SanMarino' })},
{value:'Saint Martin',Meta: props.intl.formatMessage({ id: 'Land.SaintMartin' })},
{value:'São Tomé och Príncipe',Meta: props.intl.formatMessage({ id: 'Land.SaoTomeAndPrincipe' })},
{value:'Saudiarabien',Meta: props.intl.formatMessage({ id: 'Land.SaudiArabia' })},
{value:'Schweiz',Meta: props.intl.formatMessage({ id: 'Land.Switzerland' })},
{value:'Senegal',Meta: props.intl.formatMessage({ id: 'Land.Senegal' })},
{value:'Serbien',Meta: props.intl.formatMessage({ id: 'Land.Serbia' })},
{value:'Seychellerna',Meta: props.intl.formatMessage({ id: 'Land.Seychelles' })},
{value:'Sierra Leone',Meta: props.intl.formatMessage({ id: 'Land.SierraLeone' })},
{value:'Singapore',Meta: props.intl.formatMessage({ id: 'Land.Singapore' })},
{value:'Slovakien',Meta: props.intl.formatMessage({ id: 'Land.Slovakia' })},
{value:'Slovenien',Meta: props.intl.formatMessage({ id: 'Land.Slovenia' })},
{value:'Somalia',Meta: props.intl.formatMessage({ id: 'Land.Somalia' })},
{value:'Spanien',Meta: props.intl.formatMessage({ id: 'Land.Spain' })},
{value:'Sri Lanka',Meta: props.intl.formatMessage({ id: 'Land.SriLanka' })},
{value:'Storbritannien',Meta: props.intl.formatMessage({ id: 'Land.UnitedKingdom' })},
{value:'Sudan',Meta: props.intl.formatMessage({ id: 'Land.Sudan' })},
{value:'Surinam',Meta: props.intl.formatMessage({ id: 'Land.Suriname' })},
{value:'Swaziland',Meta: props.intl.formatMessage({ id: 'Land.Swaziland'}) },
{value:'Sverige',Meta: props.intl.formatMessage({ id: 'Land.Sweden' })},
{value:'Sydafrika',Meta: props.intl.formatMessage({ id: 'Land.SouthAfrica' })},
{value:'Sydkorea',Meta: props.intl.formatMessage({ id: 'Land.SouthKorea' })},
{value:'Syrien',Meta: props.intl.formatMessage({ id: 'Land.Syria' })},
{value:'Tadzjikistan',Meta: props.intl.formatMessage({ id: 'Land.Tajikistan' })},
{value:'Taiwan',Meta: props.intl.formatMessage({ id: 'Land.Taiwan' })},
{value:'Tanzania',Meta: props.intl.formatMessage({ id: 'Land.Tanzania' })},
{value:'Tchad',Meta: props.intl.formatMessage({ id: 'Land.Chad' })},
{value:'Thailand',Meta: props.intl.formatMessage({ id: 'Land.Thailand' })},
{value:'Tjeckien',Meta: props.intl.formatMessage({ id: 'Land.CzechRepublic' })},
{value:'Togo',Meta: props.intl.formatMessage({ id: 'Land.Togo' })},
{value:'Tonga',Meta: props.intl.formatMessage({ id: 'Land.Tonga' })},
{value:'Trinidad och Tobago',Meta: props.intl.formatMessage({ id: 'Land.TrinidadAndTobago' })},
{value:'Tunisien',Meta: props.intl.formatMessage({ id: 'Land.Tunisia' })},
{value:'Turkiet',Meta: props.intl.formatMessage({ id: 'Land.Turkey' })},
{value:'Turkmenistan',Meta: props.intl.formatMessage({ id: 'Land.Turkmenistan' })},
{value:'Tuvalu',Meta: props.intl.formatMessage({ id: 'Land.Tuvalu' })},
{value:'Tyskland',Meta: props.intl.formatMessage({ id: 'Land.Germany' })},
{value:'Uganda',Meta: props.intl.formatMessage({ id: 'Land.Uganda' })},
{value:'Ukraina',Meta: props.intl.formatMessage({ id: 'Land.Ukraine' })},
{value:'Ungern',Meta: props.intl.formatMessage({ id: 'Land.Hungary' })},
{value:'Uruguay',Meta: props.intl.formatMessage({ id: 'Land.Uruguay' })},
{value:'USA',Meta: props.intl.formatMessage({ id: 'Land.UnitedStates' })},
{value:'Uzbekistan',Meta: props.intl.formatMessage({ id: 'Land.Uzbekistan' })},
{value:'Vanuatu',Meta: props.intl.formatMessage({ id: 'Land.Vanuatu' })},
{value:'Vatikanstaten',Meta: props.intl.formatMessage({ id: 'Land.VaticanCity' })},
{value:'Venezuela',Meta: props.intl.formatMessage({ id: 'Land.Venezuela' })},
{value:'Vietnam',Meta: props.intl.formatMessage({ id: 'Land.Vietnam' })},
{value:'Vitryssland',Meta: props.intl.formatMessage({ id: 'Land.Belarus' })},
{value:'Yemen',Meta: props.intl.formatMessage({ id: 'Land.Yemen' })},
{value:'Zambia',Meta: props.intl.formatMessage({ id: 'Land.Zambia' })},
{value:'Zimbabwe',Meta: props.intl.formatMessage({ id: 'Land.Zimbabwe' })},
{value:'Österrike',Meta: props.intl.formatMessage({ id: 'Land.Austria' })},
{value:'Östtimor',Meta: props.intl.formatMessage({ id: 'Land.EastTimor' })},
{value:'French Polynesia',Meta: props.intl.formatMessage({ id: 'Land.FrenchPolynesia' })},
]
    //Sverige
    const [Value,setValue] = React.useState("")
    React.useEffect(()=>{
        setValue(isNull(props.Value) || isUndefined(props.Value)?"":props.Value==='Sweden'?"Sverige":props.Value)
    },[props.Value])
    const onchangeHandle=(e)=>{
        props.onCahngeHandel(e)
    }
    console.log(Value,"DeliveryCountry")
    return (
        <div className={'w-100'}>
        <TextField
        select
        fullWidth
        variant="outlined"
        size="small"
        name={props.name}
        label={`${ props.label }:`}
        value={Value.toUpperCase()}
        disabled={props.disabled}
        InputLabelProps={{ shrink: true }}
        onChange={onchangeHandle}
        SelectProps={{
            native: true,
        }}
       >
           {
               Option9.map(item=>{
                   return <option value={item.value.toUpperCase()}>{item.Meta}</option>
                   })
        }
        </TextField>
        </div>
    )
}
export default injectIntl(NotyInputs)